module.exports = __webpack_public_path__ + "6bfdcfecf655049390be448bae126d00.svg";